import React, { useEffect, useRef, useState } from 'react';
import { BlockPortal } from './RegisterBlock.js';

export function PostContent({ children, className: publicClass }) {
  const [transpose, setTranspose] = useState();
  const divref = useRef();

  useEffect(() => {
    if (divref.current) {
      divref.current.innerHTML = children;
      setTranspose(true);
    }
  }, [divref, children, setTranspose]);

  if (!children) {
    return null;
  }

  const className = ['lh-copy'];
  if (publicClass) {
    className.push(publicClass);
  }

  return (
    <>
      <div className={className.join(' ')} ref={divref} />
      {transpose && <BlockPortal node={divref} />}
    </>
  );
}

export default PostContent;
